{
  "name": "55-Critical Band",
  "description": "55-tone 19-Limit Rational Intonation scale, based on James Tenney’s \"Critical Band\". The tones fan out geometrically around A 440, suggesting a sequence of fundamentals rising by octaves (127:128:129, 63:64:65, 31:32:33, 15:16:17, 7:8:9, 3:4:5, 1:2:3). As the frequency band widens, the chords become increasingly harmonic. The space between G-sharp and A-sharp is filled with small steps, the remaining pitch classes make a chromatic harmonic scale.",
  "scale": [
    "129/128",
    "65/64",
    "33/32",
    "17/16",
    "17/16",
    "17/16",
    "9/8",
    "9/8",
    "9/8",
    "9/8",
    "9/8",
    "19/16",
    "19/16",
    "19/16",
    "19/16",
    "19/16",
    "5/4",
    "5/4",
    "5/4",
    "5/4",
    "21/16",
    "21/16",
    "21/16",
    "21/16",
    "21/16",
    "11/8",
    "11/8",
    "23/16",
    "23/16",
    "3/2",
    "3/2",
    "3/2",
    "3/2",
    "3/2",
    "25/16",
    "25/16",
    "25/16",
    "25/16",
    "25/16",
    "13/8",
    "13/8",
    "27/16",
    "27/16",
    "7/4",
    "7/4",
    "7/4",
    "29/16",
    "29/16",
    "15/8",
    "15/8",
    "31/16",
    "31/16",
    "63/32",
    "127/64",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "55-Critical Band",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "note_names": [
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C",
    "C",
    "C",
    "C",
    "C",
    "C",
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "F",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "127°"
  ],
  "note_colors": [
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#f5ffe0",
    "#fbf6e0",
    "#ffdbdb",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -16.102113751
}
